import { Box, Chip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useMainContext } from './Layout';
import ViewPDF from 'components/PDF/ViewPDF';
import { ArrowBack, ArrowForward, CheckCircle } from '@mui/icons-material';
import PrimaryIconButton from 'components/Button/PrimaryIconButton';

const CertificatePdf = () => {
  const { cert, certVerify, setCert, setCertVerify } = useMainContext();

  const onClickBack = () => {
    setCert(certVerify.list[certVerify.index - 1].file);
    setCertVerify(prev => ({
      ...prev,
      index: prev.index - 1,
    }));
  };

  const onClickNext = () => {
    setCert(certVerify.list[certVerify.index + 1].file);
    setCertVerify(prev => ({
      ...prev,
      index: prev.index + 1,
    }));
  };
  const [widthValidAnnounce, setWidthValidAnnounce] = useState('100%');

  return (
    <Box
      flex={3}
      display={Boolean(cert) ? 'block' : 'none'}
      sx={{
        transition: 'all 0.5s ease',
        maxHeight: 'calc(100vh - 64px)',
        overflow: 'scroll',
        bgcolor: 'rgba(222, 222, 222, 1)',
        p: '15px',
      }}>
      <Box
        p={'15px'}
        display={'flex'}
        gap={'10px'}
        alignItems={'center'}
        bgcolor={'rgba(232, 255, 249, 1)'}
        mb={'10px'}
        width={widthValidAnnounce}
        mx={'auto'}>
        <CheckCircle
          sx={{
            color: 'rgba(71, 184, 129, 1)',
          }}
        />
        <Typography fontWeight={600}>Certificate is valid</Typography>
      </Box>
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
        height={{
          xs: '100vh',
          md: 'calc(100vh - 250px)',
        }}>
        <ViewPDF url={cert} setWidthSameDocument={setWidthValidAnnounce} />
      </Box>
      {certVerify?.list?.length > 1 && (
        <Box
          display={'flex'}
          maxWidth={'100%'}
          gap={'20px'}
          justifyContent={'center'}
          alignItems={'center'}
          mt={'20px'}>
          <PrimaryIconButton disabled={certVerify?.index === 0} onClick={onClickBack}>
            <ArrowBack />
          </PrimaryIconButton>

          <Chip
            label={`${certVerify?.index + 1} of ${certVerify?.list?.length}`}
            sx={{
              px: '35px',
              py: '20px',
              borderRadius: '50px',
              bgcolor: 'white',
              fontWeight: 600,
            }}
          />
          <PrimaryIconButton disabled={certVerify?.index === certVerify?.list?.length - 1} onClick={onClickNext}>
            <ArrowForward />
          </PrimaryIconButton>
        </Box>
      )}
    </Box>
  );
};

export default CertificatePdf;
